import { get as _get } from 'lodash'

const r_0 = '退保损失提示：投保人在保单犹豫期后解除合同会遭受一定损失，具体保单利益请以保单合同为准。'
const r_1 = '利益演示说明：所有利益演示均基于保险公司的假设，不代表该公司的历史经营业绩和对未来经营业绩的预期；演示数据可能存在舍入误差，实际以保险合同为准。'
const r_2 = '分红不确定性：本方案包含分红保险，保单持有人可享有分红型保险产品的盈余分配权，但未来保单红利为非保证利益，红利分配不确定，实际金额根据分红保险业务实际经营情况决定。'
const r_3 = '万能险特别提示：本方案包含万能保险，最低保证利率之上的演示数据是不确定的，实际保单账户利益以实际经营情况为准。'
// const r_4 = '温馨提示：以上演示说明为本平台对上述产品的理解，便于保险从业人员学习、交流，演示数据仅供参考，请以实际为准。'
const r_4 = '温馨提示：本宣传材料/演示说明仅供保险从业人员学习、交流使用，数据仅供参考，详细内容以保单条款和正式保险合同为准。'

// 分红险：由 initInterest 返回数据中任意一项 bonus 有值判断
// 万能险：使用 productGroupList[0].prodOrderList 下各 product 的 mulInsOrderList 中是否存在 account === true 判断
const riskContent = (hasInterestDemo = true, hasMulInsAccount = null, hasBonus = null) => {
  let result = []

  if (hasBonus) {
    result.push(r_2)
  }
  if (hasMulInsAccount) {
    result.push(r_3)
  }
  if (hasInterestDemo) {
    result.unshift(r_1)
  }
  result.unshift(r_0)
  result.push(r_4)

  return result
}

/**
 * 拼出要展示的几条风险提示话术（导出长图等地方可以复用）。
 * 万能：用 plainResultData 里 productGroupList 算；分红：优先 riskHasBonus，否则看 interestData.bonusRateFlag。
 *
 * @param {Object} options
 * @param {Object} [options.plainResultData={}] 计划书接口原始数据
 * @param {Object} [options.interestData] 没传 riskHasBonus 时用 curProductInterestData.bonusRateFlag
 * @param {boolean} [options.riskHasInterestDemo] 只有明确传 false 才去掉「利益演示说明」；不传当 true
 * @param {boolean|undefined} [options.riskHasBonus] 传了 true/false 就用它；不传按 interestData
 * @returns {string[]}
 */
export function getRiskPromptLines ({
  plainResultData = {},
  interestData = null,
  riskHasInterestDemo,
  riskHasBonus
} = {}) {
  const prodOrderList = _get(plainResultData, 'resultData.productGroupList[0].prodOrderList') || []
  const hasMulInsAccountLocal = prodOrderList.some(prod =>
    (prod.mulInsOrderList || []).some(ins => ins.account === true)
  )

  const hasInterestDemoResolved = riskHasInterestDemo !== false
  const hasBonusResolved =
    typeof riskHasBonus === 'boolean'
      ? riskHasBonus
      : !!_get(interestData, 'curProductInterestData.bonusRateFlag')

  return riskContent(hasInterestDemoResolved, hasMulInsAccountLocal, hasBonusResolved)
}

export default riskContent
